module.exports = function(ngModule) {
  require('./alertDirective')(ngModule);
};